import React from 'react'
import '../styles/Footer.css'
import { Link } from "react-scroll";
export default function Footer() {
    return (
        <>
            <div className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 col-6">
                            <div className="links">
                                <h3><i className="fas fa-caret-right"></i> Sitemap</h3>
                                <a>About Us</a>
                                <a>Courses</a>
                                <a>Upcoming</a>
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="links">
                                <h3><i className="fas fa-caret-right"></i> More</h3>
                                <a>Join Us</a>
                                <a>Contact Us</a>
                            </div>
                        </div>
                        <div className="col-md-3 col-12">
                            <div className="social">
                            <h3><i className="fas fa-caret-right"></i> Social links</h3>
                            <a><i className="fas fa-globe"></i> www.asmaasaad.com</a>
                            <a><i className="fas fa-envelope"></i> asmaa7bank@gmail.com</a>
                            <a><i className="fas fa-phone"></i> 0234567890</a>
                            </div>
                        </div>
                        <div className="col-md-3 col-12">
                            <div className="social">
                                <h3><i className="fas fa-caret-right"></i> Social links</h3>
                                <a><i className="fab fa-behance"></i> Behance</a>
                                <a><i className="fab fa-github"></i> Github</a>
                                <a><i className="fab fa-codepen"></i> Codepen</a>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="image text-center">
                                <Link to="/">
                                    <img src="./logo.png" alt="image"/>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <hr style={{position: "relative",backgroundColor: "#eeeeee62"}}/>
                    <div className="copyright text-center">
                        All Rights Reserved 2021 © <span> Asmaa Saad </span>
                    </div>
                    </div>
            </div>
        </>
    )
}
